import React from 'react';
import { Facebook, Instagram, Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  const navigation = [
    { name: 'Home', href: '/#home' },
    { name: 'About', href: '/#about' },
    { name: 'Services', href: '/#services' },
    { name: 'Portfolio', href: '/#portfolio' },
    { name: 'Contact', href: '/#contact' },
  ];

  return (
    <footer className="border-t border-white/10 bg-black px-6 py-16 text-white md:px-10">
      <div className="mx-auto grid max-w-7xl gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="text-3xl leading-tight">ThirtyFive Studio</p>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#d0d0d0]">
            Web Development, Branding, App Development – All in One Studio
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="mb-4 text-xs uppercase tracking-[0.14em] text-[#d0d0d0]">Navigate</p>
          <ul className="space-y-3">
            {navigation.map((item) => (
              <li key={item.name}>
                <a href={item.href} className="text-sm text-white hover:text-[#d0d0d0]">
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="mb-4 text-xs uppercase tracking-[0.14em] text-[#d0d0d0]">Contact</p>
          <ul className="space-y-3 text-sm text-white">
            <li className="flex items-center gap-2">
              <Mail className="h-4 w-4" />
              <a href="mailto:info@thirtyfivestudio.com">info@thirtyfivestudio.com</a>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="h-4 w-4" />
              <a href="tel:+16512198788">+1 (651) 219-8788</a>
            </li>
            <li className="flex items-center gap-2">
              <MapPin className="h-4 w-4" />
              <a href="/#where-we-work">Twin Cities, Rochester, MN</a>
            </li>
          </ul>
          <div className="mt-6 flex gap-4">
            <a href="https://www.facebook.com/profile.php?id=61572092622021" aria-label="Facebook" className="text-white hover:text-[#d0d0d0]">
              <Facebook className="h-5 w-5" />
            </a>
            <a href="https://www.instagram.com/thirtyfivestudiohq/" aria-label="Instagram" className="text-white hover:text-[#d0d0d0]">
              <Instagram className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>

      <p className="mx-auto mt-16 max-w-7xl border-t border-white/10 pt-6 text-sm text-[#d0d0d0]">
        © 2026 ThirtyFive Studio, LLC. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
